let Radio = {
  baseStyle: {
    label: {
      boxSizing: "border-box",
      padding: 0,
      _disabled: {
        color: "slate.400"
      }
    },
    control: {
      height: "2xs",
      width: "2xs",
      border: "1px solid",
      borderColor: "slate.300",
      borderRadius: "50%",
      _dark: {
        borderColor: "rgba(255, 255, 255, 0.25)",
        _hover: {
          borderColor: "rgba(255, 255, 255, 0.5)"
        },
        _disabled: {
          bg: "grayscale.850",
          borderColor: "rgba(255, 255, 255, 0.25)"
        }
      },
      _focus: {
        _before: {
          content: '""',
          position: "absolute",
          height: "2xs",
          width: "2xs",
          border: "0.125rem solid",
          borderColor: "blue.500",
          borderRadius: "50%",
          padding: "0.125rem"
        }
      },
      _hover: {
        borderColor: "slate.600"
      },
      _disabled: {
        borderColor: "slate.200",
        bg: "slate.50"
      },
      _checked: {
        bg: "transparent",
        borderColor: "blue.500",
        _after: {
          content: '""',
          height: "50%",
          width: "50%",
          bg: "blue.500",
          borderRadius: "50%",
          borderColor: "blue.500"
        }
      }
    }
  },
  sizes: {
    sm: {
      label: {
        fontSize: "text-xs"
      },
      control: {
        height: "0.75rem",
        width: "0.75rem",
        _focus: {
          _before: {
            height: "0.75rem",
            width: "0.75rem"
          }
        }
      }
    },
    md: {
      label: {
        fontSize: "text-sm"
      },
      control: {
        height: "1.125rem",
        width: "1.125rem",
        _focus: {
          _before: {
            height: "1.125rem",
            width: "1.125rem"
          }
        }
      }
    },
    lg: {
      label: {
        fontSize: "text-lg"
      },
      control: {
        height: "1.375rem",
        width: "1.375rem",
        _focus: {
          _before: {
            height: "1.375rem",
            width: "1.375rem"
          }
        }
      }
    },
    xl: {
      label: {
        fontSize: "text-xl"
      },
      control: {
        height: "1.5rem",
        width: "1.5rem",
        _focus: {
          _before: {
            height: "1.5rem",
            width: "1.5rem"
          }
        }
      }
    }
  },
  variants: {
    outline: {}
  },
  defaultProps: {
    size: "md"
  }
};

export { Radio };
